module.exports = __webpack_public_path__ + "img/hsh.c84ae18a.png";